module.exports = __webpack_public_path__ + "3203e2fbf7da98d1caf9c03f44239f15.png";